import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState, useLayoutEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import toast from 'react-hot-toast';
import API from './services/api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Flows from './pages/Flows';
import Contacts from './pages/Contacts';
import Navbar from './components/Navbar';
import FlowBuilder from './pages/FlowBuilder';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Organization from './pages/Organization';
import Statistics from './pages/Statistics';
import AIMediaLibrary from './pages/AIMediaLibrary';
import AdminSubscriptions from './pages/AdminSubscriptions';
import { useNavigate } from 'react-router-dom';




// ✅ Admin page imports
import LandingPage from './pages/LandingPage';
import PricingPlans from './pages/PricingPlans';
import Checkout from './pages/Checkout';
import SubscriptionAlert from './components/SubscriptionAlert';
import AdminDashboard from './pages/AdminDashboard';
import OrganizationsList from './pages/OrganizationsList';
import OrganizationDetails from './pages/OrganizationDetails';
import AIAssistants from './pages/AIAssistants';

import HowItWorks from './pages/HowItWorks';
import Features from './pages/Features';
import Services from './pages/Services';
import ContactPage from './pages/ContactPage';
import BulkMessage from './pages/BulkMessage';
import CampaignDetails from './pages/CampaignDetails';
import RecipientConversation from './pages/RecipientConversation';
import FailedRecipients from './pages/FailedRecipients';
import ScheduleMessage from './pages/ScheduleMessage';
import OrganizeNumbers from './pages/OrganizeNumbers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import OtpService from './pages/OtpService';
import TermsAndConditions from './pages/TermsAndConditions';



// ✅ SuperAdminGuard — normal user ko /admin pe access nahi
const SuperAdminGuard = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';

  <Navigate to="/" state={{ openLogin: true }} />
  if (!isSuperAdmin) return <Navigate to="/dashboard" />;
  return children;
};
// ✅ ProtectedRoute Guard using React Router location
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';
  const subscriptionStatus = localStorage.getItem('subscriptionStatus');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isSuperAdmin) {
    return children;
  }

  // ✅ ONLY block if status is EXPLICITLY 'none'
  const isNewUser = subscriptionStatus === 'none' || !subscriptionStatus;
  const currentPath = location.pathname;

  const allowedPathsForNewUser = ['/dashboard', '/pricing', '/checkout', '/login'];

  if (isNewUser && !allowedPathsForNewUser.includes(currentPath)) {
    toast.error('Please choose a plan to access platform features!');
    return <Navigate to="/pricing" replace />;
  }

  return children;
};
// ✅ Professional Deactivation Alert Component
const DeactivationAlert = ({ message, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 99999,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '0',
        maxWidth: '420px',
        width: '90%',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
        overflow: 'hidden',
        animation: 'slideDown 0.25s ease-out',
      }}>
        <div style={{
          backgroundColor: '#dc2626',
          padding: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <div>
            <h3 style={{
              margin: 0,
              fontSize: '20px',
              fontWeight: '700',
              color: '#ffffff',
              letterSpacing: '-0.5px',
            }}>
              Account Deactivated
            </h3>
            <p style={{
              margin: '2px 0 0 0',
              fontSize: '13px',
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: '500',
            }}>
              Access Denied
            </p>
          </div>
        </div>

        <div style={{ padding: '24px' }}>
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '14px',
            marginBottom: '20px',
          }}>
            <p style={{
              margin: 0,
              fontSize: '14px',
              lineHeight: '1.5',
              color: '#991b1b',
            }}>
              {message || 'Your account has been deactivated. You cannot login until your account is reactivated by the administrator.'}
            </p>
          </div>

          <div style={{
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '20px',
          }}>
            <p style={{
              margin: '0 0 10px 0',
              fontSize: '13px',
              fontWeight: '600',
              color: '#374151',
            }}>
              📞 What should you do?
            </p>
            <ul style={{
              margin: 0,
              paddingLeft: '18px',
              fontSize: '13px',
              lineHeight: '1.6',
              color: '#6b7280',
            }}>
              <li>Contact your administrator or support team</li>
              <li>Provide your account email for verification</li>
              <li>Complete payment (if required) to reactivate</li>
            </ul>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '12px',
            backgroundColor: '#eff6ff',
            borderRadius: '8px',
            marginBottom: '20px',
          }}>
            <p style={{
              margin: 0,
              fontSize: '12px',
              color: '#1e40af',
            }}>
              💡 <strong>Need Help?</strong> Contact support@chattech24.com
            </p>
          </div>

          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '12px 20px',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(220, 38, 38, 0.25)',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#b91c1c';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(220, 38, 38, 0.35)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#dc2626';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.25)';
            }}
          >
            I Understand - Close
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

function AppContent() {
    const navigate = useNavigate();

    const isAuthenticated = !!localStorage.getItem('token');
    const location = useLocation();

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

const publicPaths = ['/login', '/', '/pricing', '/terms-and-conditions', '/privacy-policy', '/how-it-works', '/features', '/services', '/contact'];  const showNavbar = isAuthenticated && !publicPaths.includes(location.pathname);
  useEffect(() => {
    let deactivationAlertShown = false;

    const responseInterceptor = API.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          console.log('🚪 401 Unauthorized - Auto logout');

          localStorage.removeItem('token');
          localStorage.removeItem('isSuperAdmin');
          localStorage.removeItem('userName');
          localStorage.removeItem('userEmail');

          toast.error('Session expired. Please login again.');

          setTimeout(() => {
            navigate('/', { state: { openLogin: true } });
          }, 1000);
        }

        // ✅ NEW: Subscription errors handle karo
        // ✅ Subscription errors handle karo
        if (error.response?.status === 403 &&
          (error.response?.data?.errorCode === 'NO_SUBSCRIPTION' ||
            error.response?.data?.errorCode === 'SUBSCRIPTION_EXPIRED')) {

          // ✅ Clear localStorage immediately
          localStorage.removeItem('subscriptionStatus');
          localStorage.removeItem('subscriptionPlan');
          localStorage.removeItem('subscriptionEndDate');

          toast.error('Subscription required! Redirecting to plans...');

          setTimeout(() => {
            window.location.href = '/pricing';
          }, 1500);

          return Promise.reject(error);
        }

        if (error.response?.status === 403 &&
          error.response?.data?.errorCode === 'ACCOUNT_DEACTIVATED' &&
          !deactivationAlertShown) {

          deactivationAlertShown = true;

          console.log('🚫 Account deactivated - Force logout');

          localStorage.clear();

          const errorMessage = error.response?.data?.message ||
            'Your account has been deactivated. You cannot login until your account is reactivated by the administrator.';

          setAlertMessage(errorMessage);
          setShowAlert(true);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      API.interceptors.response.eject(responseInterceptor);
      deactivationAlertShown = false;
    };
  }, [navigate]);

  const handleCloseAlert = () => {
    setShowAlert(false);
    navigate('/', { state: { openLogin: true } });
  };

  return (
    <>
      {showAlert && (
        <DeactivationAlert
          message={alertMessage}
          onClose={handleCloseAlert}
        />
      )}

      {/* ✅✅✅ PROFESSIONAL TOAST NOTIFICATIONS */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={16}
        containerStyle={{
          top: 80,    // ✅ Add this - navbar se neeche
          right: 20,
          zIndex: 999999,  // ✅ Higher than navbar
        }}
        toastOptions={{
          // ✅ SUCCESS Toast - Beautiful Green
          success: {
            duration: 4000,
            style: {
              background: '#10b981',
              color: '#ffffff',
              padding: '16px 20px',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(16, 185, 129, 0.4)',
              border: 'none',
              minWidth: '350px',
              maxWidth: '500px',
            },
            iconTheme: {
              primary: '#ffffff',
              secondary: '#10b981',
            },
          },

          // ✅ ERROR Toast - Professional Red
          error: {
            duration: 5000,
            style: {
              background: '#ef4444',
              color: '#ffffff',
              padding: '16px 20px',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(239, 68, 68, 0.4)',
              border: 'none',
              minWidth: '350px',
              maxWidth: '500px',
            },
            iconTheme: {
              primary: '#ffffff',
              secondary: '#ef4444',
            },
          },

          // ✅ LOADING Toast - Blue
          loading: {
            duration: Infinity,
            style: {
              background: '#3b82f6',
              color: '#ffffff',
              padding: '16px 20px',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              boxShadow: '0 10px 30px rgba(59, 130, 246, 0.4)',
              border: 'none',
              minWidth: '350px',
              maxWidth: '500px',
            },
            iconTheme: {
              primary: '#ffffff',
              secondary: '#3b82f6',
            },
          },

          // ✅ DEFAULT Toast
          style: {
            background: '#ffffff',
            color: '#1f2937',
            padding: '16px 20px',
            borderRadius: '10px',
            fontSize: '15px',
            fontWeight: '500',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            border: '1px solid #e5e7eb',
            minWidth: '350px',
            maxWidth: '500px',
          },
        }}
      />

      {showNavbar && <Navbar />}
      {isAuthenticated && !publicPaths.includes(location.pathname) && <SubscriptionAlert />}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/pricing" element={<PricingPlans />} />
        <Route path="/checkout" element={isAuthenticated ? <Checkout /> : <Navigate to="/login" />} />

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
<Route path="/flows" element={<ProtectedRoute><Flows /></ProtectedRoute>} />
<Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
<Route path="/flow-builder" element={<ProtectedRoute><FlowBuilder /></ProtectedRoute>} />
<Route path="/flow-builder/:id" element={<ProtectedRoute><FlowBuilder /></ProtectedRoute>} />
<Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
<Route path="/bulk-message" element={<ProtectedRoute><BulkMessage /></ProtectedRoute>} />
<Route path="/schedule-message" element={<ProtectedRoute><ScheduleMessage /></ProtectedRoute>} />
<Route path="/otp-service" element={<ProtectedRoute><OtpService /></ProtectedRoute>} />
<Route path="/bulk-message/organize" element={<ProtectedRoute><OrganizeNumbers /></ProtectedRoute>} />
<Route path="/bulk-message/campaign/:id" element={<ProtectedRoute><CampaignDetails /></ProtectedRoute>} />
<Route path="/bulk-message/campaign/:id/recipient/:contactId" element={<ProtectedRoute><RecipientConversation /></ProtectedRoute>} />
<Route path="/bulk-message/campaign/:id/failed" element={<ProtectedRoute><FailedRecipients /></ProtectedRoute>} />
<Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
<Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
<Route path="/ai-assistants" element={<ProtectedRoute><AIAssistants /></ProtectedRoute>} />
<Route path="/organization" element={<ProtectedRoute><Organization /></ProtectedRoute>} />
<Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<SuperAdminGuard><AdminDashboard /></SuperAdminGuard>} />
        <Route path="/admin/clients" element={<SuperAdminGuard><OrganizationsList /></SuperAdminGuard>} />
        <Route path="/admin/client/:id" element={<SuperAdminGuard><OrganizationDetails /></SuperAdminGuard>} />
        <Route path="/admin/subscriptions" element={<SuperAdminGuard><AdminSubscriptions /></SuperAdminGuard>} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/features" element={<Features />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;